import { Component, computed, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxPopoverModule } from '@aposin/ng-aquila/popover';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';

import UserService from '#services/user/user.service';

@UntilDestroy()
@Component({
  selector: 'kyc-business-unit-selector',
  templateUrl: './business-unit-selector.component.html',
  imports: [
    ReactiveFormsModule,
    NxFormfieldModule,
    NxPopoverModule,
    NxDropdownModule,
    NxSpinnerModule,
    TranslateModule,
  ],
})
export class BusinessUnitSelectorComponent {
  private readonly userService = inject(UserService);

  protected readonly buCodeControl = new FormBuilder().control('', Validators.required);

  constructor() {
    this.buCodeControl.valueChanges.pipe(untilDestroyed(this)).subscribe((newVal) => {
      if (newVal) this.userService.setBuCode(newVal);
    });
  }

  protected potentialBuCodesSignal = computed(() => {
    const buCodes = this.userService.potentialBuCodesSignal();
    if (buCodes.length === 1) {
      this.buCodeControl.patchValue(buCodes[0]);
      this.buCodeControl.disable();
    }
    return buCodes;
  });
}
